import { request } from "../utils/axios";
import {
  getSessionId,
  getSessionData,
  getShadowRoot,
  setSessionData,
} from "../utils/store";
import { nextPrev, ShutterSound } from "../utils/StepService";
import flatpickrCss from "flatpickr/dist/themes/dark.css";
import { setError, setLoading } from "../utils";

class MultiAngleFaceCapture {

  videoWidth = 360;
  videoHeight = 640;

  directions = ['left', 'right', 'up', 'down'];
  currentPose = 0;
  capturing = false;
  capturedDirections = {
    left: false,
    right: false,
    up: false,
    down: false,
  };

  capturedImages = [];
  camera = null;
  stream = null;
  frameRequest = null;
  isCameraStarting = false;
  poseHoldStartAt = null;
  poseTransitionUntil = 0;
  poseHoldDurationMs = 500;
  poseTransitionDelayMs = 700;
  hasPoseResetSincePrompt = false;
  capturedUpRatio = null;
  capturedUpDownMetric = null;
  captureRunId = 0;

  baselineFaceHeight = null;
  lastFaceHeight = 0;
  isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

 
  formData = new FormData();
  isProcessingCapture = false;
  consentDetails;
  sessionData;
  isFaceMeshReady = false;
  faceMesh = null;
  colorMap = {
    center: "👈",
    left: "👈",
    right: "👉",
    up: "👆",
    down: "👇"
  };

  getDirectionPrompt(direction) {
    switch (direction) {
      case 'left':
        return 'Slowly turn left';
      case 'right':
        return 'Slowly turn right';
      case 'up':
        return 'Slowly look up';
      case 'down':
        return 'Slowly look down';
      default:
        return '';
    }
  }

  render = async () => {
    this.sessionData = getSessionData();
    if (this.sessionData?.profileDetails?.showFromUpdateInfo === true) {
      this.personalInfoObj = await this.getProfileDetails();
    }
    let modalBox = getShadowRoot().querySelector("#identity-modal__box");

    if (modalBox.querySelector("#multiAngleFaceDetection")) return;

    const flatpickrStyleSheet = document.createElement("style");
    flatpickrStyleSheet.textContent = flatpickrCss;
    getShadowRoot().appendChild(flatpickrStyleSheet);

    modalBox.insertAdjacentHTML(
      "beforeend",
      ` 
        <form class="form-content selfi-verification" id="multiAngleFaceDetection" data-form-tab>
            <h3>Face Direction Capture</h3>
        <div class="identity__row">
            <div class="identity__col-12">
                <div class="identity-alert__error" id="identity-alert__error" style="display:none;">
                <button data-close="close" style="display:none;" type="button">&times;</button>
                <svg class="icon" width="20px" height="20px" aria-hidden="true" role="img"><use href="#svg__alert-error" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg__alert-error"></use></svg>
                <div id="identity-alert__message" data-text="text"></div>
              </div>
          </div>
            <div class="face-error" id="faceCaptureError" style="display:none;">
              <svg class="svg" width="64px" height="64px" aria-hidden="true" role="img"><use href="#svg__error" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg__error"></use></svg>
                <h2>Sorry!</h2>
                <div id="faceCapture-message"></div>
            </div>
             <div class="face-loading" id="faceLoading" style="display:none;">
                 <svg class="svg" width="60px" height="60px" aria-hidden="true" role="img">
                    <use href="#svg__loader" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg__loader"></use>
                  </svg>
               <div>Please wait; we are finishing up!</div>
             </div>
          <!-- 🔊 Audio element for shutter sound -->
        <audio id="shutterSound" preload="auto">
          <source src="sound.mp3" type="audio/mpeg" >
        </audio>

          <div id="mainContainer">
            <div id="videoContainer">
              <video id="video" autoplay muted playsinline></video>
              <canvas id="landmarksCanvas"></canvas>
              <div class="multi-angle-face-guide" id="multiAngleFaceGuide"></div>
              <div id="instructions">⏳ Loading...</div>
              </div>
          <div class="multi-angle-direction-status" id="multiAngleDirectionStatus"></div>
          <div id="capturedImages"></div>
            <canvas id="canvas" style="display:none;"></canvas>
        </div>
          <div class="identity__col-12">
            <div class="identity-field">
              <button class="identity-btn" id="btn-continue" type="submit">Start Capture
                <span class="loading-icon">
                  <svg class="svg" width="20px" height="20px" aria-hidden="true" role="img">
                    <use href="#svg__loader" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg__loader"></use>
                  </svg>
                </span>
              </button>
          </div>
        </div>
         ${this.sessionData.configurationType !== 2 ? `<div class="identity__col-12">
             <div class="identity-field ">
                <button type="button" class="identity-btn identity-btn__secondary" id="skip">Skip </button>
            </div>` : ""}
        </form>
  `
    );
    this.bindEvents();
  };


  async bindEvents() {
    const title = getShadowRoot().querySelector(`#identityLeftMessage`);
    const message = getShadowRoot().querySelector(`.identity__h1`);
    const logo = getShadowRoot().querySelector(`.identity__logo`);
    title.style.display = 'none';
    message.style.display = 'none';
    logo.style.display = 'none';
    const multiAngleFaceDetectionForm = getShadowRoot().querySelector(`#multiAngleFaceDetection`);
    const skipButton = multiAngleFaceDetectionForm.querySelector("#skip");
    ShutterSound.init();

    if (this.sessionData.configurationType !== 2) {
      skipButton.addEventListener("click", () => {
        this.SendOption(false);
      })
    }

    window.addEventListener('resize', this.updateCanvasDimensions);
    const video = multiAngleFaceDetectionForm.querySelector('#video');
    const landmarksCanvas = multiAngleFaceDetectionForm.querySelector('#landmarksCanvas');
    const overlayCtx = landmarksCanvas.getContext('2d');
    const instructions = multiAngleFaceDetectionForm.querySelector('#instructions');
    const btn_continue = multiAngleFaceDetectionForm.querySelector('#btn-continue');
    const videoContainer = multiAngleFaceDetectionForm.querySelector('#videoContainer');
    const faceCaptureError = multiAngleFaceDetectionForm.querySelector('#faceCaptureError');
    const faceCaptureMessage = multiAngleFaceDetectionForm.querySelector('#faceCapture-message');
    const loader = multiAngleFaceDetectionForm.querySelector('#faceLoading');
    await this.initFaceMesh()

    btn_continue.disabled = true;
    video.style.display = 'none';

    this.faceMesh.onResults((results) => {
      if (!this.isFaceMeshReady) {
        this.isFaceMeshReady = true;
        btn_continue.disabled = false;
        video.style.display = 'flex';
        instructions.textContent = "Ready! Click 'Start Capture'";
        this.renderDirectionStatus();
        instructions.textContent = "✅ Ready! Click 'Start Capture'";
      }
      if (
        !this.capturing &&
        !this.isProcessingCapture &&
        this.currentPose === 0 &&
        !this.capturedImages.length &&
        this.isFaceMeshReady
      ) {
        instructions.textContent = "Ready! Click 'Start Capture'";
      }
      overlayCtx.clearRect(0, 0, landmarksCanvas.clientWidth, landmarksCanvas.clientHeight);
      if (!this.capturing) return;

      if (results.multiFaceLandmarks && results.multiFaceLandmarks.length > 0) {
        const landmarks = results.multiFaceLandmarks[0];
        // Use the camera's native resolution (not the CSS-rendered container box) so aspect-ratio-sensitive checks stay accurate.
        const isCorrect = this.estimatePose(landmarks, video.videoWidth, video.videoHeight);

        for (const point of landmarks) {
          overlayCtx.save();  // Save current state
          overlayCtx.scale(-1, 1); // Flip horizontally
          overlayCtx.translate(-landmarksCanvas.clientWidth, 0); // Move origin
          overlayCtx.beginPath();
          overlayCtx.arc(
            point.x * landmarksCanvas.clientWidth,
            point.y * landmarksCanvas.clientHeight,
            this.isMobile ? 1 : 2,
            0,
            2 * Math.PI
          );
          overlayCtx.fillStyle = isCorrect ? 'green' : 'red';
          overlayCtx.fill();

          overlayCtx.restore(); // Restore to original state

        }

        //Check capturing is in process
        if (this.isProcessingCapture) return;  // extra safety

        if (Date.now() < this.poseTransitionUntil) {
          this.poseHoldStartAt = null;
          return;
        }

        if (!this.hasPoseResetSincePrompt) {
          if (!isCorrect) {
            this.hasPoseResetSincePrompt = true;
          } else {
            this.poseHoldStartAt = null;
            return;
          }
        }

        if (this.capturing && isCorrect && this.isFaceFullyVisible(landmarks, this.videoWidth, this.videoHeight)) {
          if (!this.poseHoldStartAt) {
            this.poseHoldStartAt = Date.now();
            instructions.textContent = "Hold still";
            return;
          }

          instructions.textContent = `📸  Capturing ${this.directions[this.currentPose].toUpperCase()}...`;
          if (Date.now() - this.poseHoldStartAt >= this.poseHoldDurationMs) {
            this.capturing = false;
            this.poseHoldStartAt = null;
            instructions.textContent = `Capturing ${this.directions[this.currentPose].toUpperCase()}...`;
            this.captureImage(landmarks).finally(() => {
              if (!this.isProcessingCapture) {
                this.capturing = true;
              }
            });
          }
        } else if (this.poseHoldStartAt) {
          this.poseHoldStartAt = null;
          this.updateInstruction(instructions);
        }
      }
    });

    this.setupCamera();

    btn_continue.onclick = async (e) => {
      if (!this.hasActiveCameraStream())
        await this.setupCamera();

      //Update element style 
      videoContainer.style.display = 'flex'
      faceCaptureError.style.display = 'none';
      faceCaptureMessage.style.display = 'none';
      instructions.style.display = 'flex';
      loader.style.display = 'none';
      btn_continue.innerHTML = `ReStart <span class="loading-icon"><svg class="svg" width="20px" height="20px" aria-hidden="true" role="img"><use href="#svg__loader" xlink:href="#svg__loader"></use></svg></span>`;

      e.preventDefault();
      this.captureRunId++;
      this.currentPose = 0;
      this.capturedUpRatio = null;
      this.capturedUpDownMetric = null;
      this.resetDirectionStatus();
      this.formData = new FormData();
      this.capturedImages.length = 0;
      multiAngleFaceDetectionForm.querySelector('#capturedImages').innerHTML = '';
      this.poseHoldStartAt = null;
      this.poseTransitionUntil = 0;
      this.hasPoseResetSincePrompt = false;
      this.capturing = true;
      this.setFaceGuideState(false, true);
      this.promptNextPose();
    };
  }


  resetDirectionStatus() {
    this.capturedDirections = {
      left: false,
      right: false,
      up: false,
      down: false,
    };
    this.renderDirectionStatus();
  }

  getDirectionText(direction) {
    switch (direction) {
      case 'left':
        return 'LEFT';
      case 'right':
        return 'RIGHT';
      case 'up':
        return 'UP';
      case 'down':
        return 'DOWN';
      default:
        return '';
    }
  }

  renderDirectionStatus() {
    const multiAngleFaceDetectionForm =
      getShadowRoot().querySelector(`#multiAngleFaceDetection`);
    const statusContainer = multiAngleFaceDetectionForm?.querySelector(
      '#multiAngleDirectionStatus'
    );

    if (!statusContainer) return;

    statusContainer.innerHTML = this.directions
      .map((direction, index) => {
        const captured = this.capturedDirections[direction];
        const active = index === this.currentPose && !captured;
        const classes = [
          'multi-angle-direction-item',
          captured ? 'captured' : 'pending',
          active ? 'active' : '',
        ].join(' ');

        return `<span class="${classes}"><span class="direction-dot"></span>${this.getDirectionText(direction)}${captured ? ' DONE' : ''}</span>`;
      })
      .join('');
  }

  setFaceGuideState(isCaptured, isVisible = this.capturing || this.isProcessingCapture) {
    const multiAngleFaceDetectionForm =
      getShadowRoot().querySelector(`#multiAngleFaceDetection`);
    const faceGuide = multiAngleFaceDetectionForm?.querySelector(
      '#multiAngleFaceGuide'
    );

    if (!faceGuide) return;

    if (isVisible) {
      faceGuide.classList.add('active');
    } else {
      faceGuide.classList.remove('active');
    }

    if (isCaptured) {
      faceGuide.classList.add('captured');
    } else {
      faceGuide.classList.remove('captured');
    }
  }


  /**
   * Check face exist or not in canvas image
   * */
  async hasFullyVisibleFaceInCanvas(canvas) {
    return new Promise((resolve) => {
      this.checkFaceFullyVisible.setOptions({
        maxNumFaces: 1,
        refineLandmarks: false,
        minDetectionConfidence: 0.5,
        minTrackingConfidence: 0.5
      });

      this.checkFaceFullyVisible.onResults((results) => {
        const landmarks = results.multiFaceLandmarks?.[0];

        if (!landmarks) {
          resolve(false); // No face at all
          return;
        }

        const keyIndices = [10, 159, 386, 33, 263, 152, 1]; // Key face points
        for (const index of keyIndices) {
          const point = landmarks[index];
          const x = point.x * canvas.width;
          const y = point.y * canvas.height;

          if (x < 0 || x > canvas.width || y < 0 || y > canvas.height) {
            resolve(false); // A key point is outside the canvas
            return;
          }
        }

        resolve(true); // Face is present and fully visible
      });

      this.checkFaceFullyVisible.send({ image: canvas });
    });
  }

  /**
   * Detect face angle
   * @param {*} landmarks 
   * @param {*} width 
   * @param {*} height 
   * @returns 
   */
  getVerticalPoseRatio(leftEye, rightEye, noseTip, width, height) {
    // Pixel-space so the ratio isn't skewed by the camera's aspect ratio (eyeToNoseDist is y-normalized, eyeDist is x-normalized).
    const eyeAvgY = (leftEye.y + rightEye.y) / 2;
    const eyeToNoseDistPx = (noseTip.y - eyeAvgY) * height;
    const eyeDistPx = Math.abs(rightEye.x - leftEye.x) * width;

    return eyeDistPx ? eyeToNoseDistPx / eyeDistPx : 0;
  }

  getDownPoseMetric(leftEye, rightEye, noseTip, chin) {
    const eyeAvgY = (leftEye.y + rightEye.y) / 2;
    const eyeToNoseDist = noseTip.y - eyeAvgY;
    const faceHeight = chin.y - eyeAvgY;

    return faceHeight ? eyeToNoseDist / faceHeight : 0;
  }

  getNoseToChinRatio(leftEye, rightEye, noseTip, chin) {
    const eyeAvgY = (leftEye.y + rightEye.y) / 2;
    const faceHeight = chin.y - eyeAvgY;
    const noseToChinDist = chin.y - noseTip.y;

    return faceHeight ? noseToChinDist / faceHeight : 0;
  }

  getHorizontalPoseRatio(leftEye, rightEye, noseTip) {
    const midEyeX = (leftEye.x + rightEye.x) / 2;
    const noseXRelative = noseTip.x - midEyeX;
    const eyeDist = Math.abs(rightEye.x - leftEye.x);

    return eyeDist ? noseXRelative / eyeDist : 0;
  }

  estimatePose(landmarks, width, height, direction) {
    const leftEye = landmarks[33];
    const rightEye = landmarks[263];
    const noseTip = landmarks[1];
    const chin = landmarks[152];

    // Pixel-space so the roll angle isn't skewed by the camera's aspect ratio (x and y are normalized by width/height independently).
    const dxPx = (rightEye.x - leftEye.x) * width;
    const dyPx = (rightEye.y - leftEye.y) * height;
    const eyeSlope = Math.atan2(dyPx, dxPx) * 180 / Math.PI;

    const midEyeX = (leftEye.x + rightEye.x) / 2;
    const noseXRelative = noseTip.x - midEyeX;

    const eyeAvgY = (leftEye.y + rightEye.y) / 2;
    const faceHeight = chin.y - eyeAvgY;
    this.lastFaceHeight = faceHeight;
    let angle = "";
    if (direction == null)
      angle = this.directions[this.currentPose]
    else
      angle = direction;
    switch (angle) {
      case 'center':
        return Math.abs(eyeSlope) < 9 && Math.abs(noseXRelative) < 0.02;

      case 'left':
        {
          // Ratio (not absolute offset) so the required turn angle is the same regardless of how close the face is to the camera.
          const horizontalRatio = this.getHorizontalPoseRatio(leftEye, rightEye, noseTip);
          return horizontalRatio > 0.20 && horizontalRatio < 0.50; // head turned right → nose appears left
        }

      case 'right':
        {
          const horizontalRatio = this.getHorizontalPoseRatio(leftEye, rightEye, noseTip);
          return horizontalRatio > -0.50 && horizontalRatio < -0.20; // head turned left → nose appears right
        }

      case 'up':
        {
          const ratio = this.getVerticalPoseRatio(leftEye, rightEye, noseTip, width, height);

          return ratio > 0.21 && ratio < 0.59;
        }
      case 'down':
        {
          const downMetric = this.getDownPoseMetric(leftEye, rightEye, noseTip, chin);
          const noseToChinRatio = this.getNoseToChinRatio(
            leftEye,
            rightEye,
            noseTip,
            chin
          );
          // Floor is a sanity minimum on the calibrated value, not a hard override, so a moderate/natural
          // downward glance is enough instead of forcing an extreme tilt that pushes the face out of frame.
          const requiredDownMetric = this.capturedUpDownMetric != null
            ? Math.max(this.capturedUpDownMetric + 0.08, 0.28)
            : 0.34;
          const faceHeightRatio = this.baselineFaceHeight
            ? faceHeight / this.baselineFaceHeight
            : null;

          return (
              downMetric > requiredDownMetric &&
              downMetric < 0.78 &&
              noseToChinRatio < 0.62 &&
              (faceHeightRatio == null || faceHeightRatio < 0.97) &&
              Math.abs(eyeSlope) < 25 &&
              Math.abs(noseXRelative) < 0.045
          );
          }
      default:
        return false;
    }
  }



  /**
   * Get face landmark from captured image
   * @param {*} landmarks 
   * @param {*} srcW 
   * @param {*} srcH 
   * @param {*} padding 
   * @returns 
   */
  // ─── HELPER: get face bbox (in pixel coords) from landmarks ───
  getFaceBox(landmarks, srcW, srcH, padding = 0.3) {
    // map normalized landmarks to raw-video pixels
    const xs = landmarks.map(p => p.x * srcW);
    const ys = landmarks.map(p => p.y * srcH);
    let minY = Math.min(...ys), maxY = Math.max(...ys);
    let minX = Math.min(...xs), maxX = Math.max(...xs);

    // add padding
    const w = maxX - minX, h = maxY - minY;
    minX = Math.max(0, minX - w * padding);
    minY = Math.max(0, minY - h * padding);
    maxX = Math.min(srcW, maxX + w * padding);
    maxY = Math.min(srcH, maxY + h * padding);

    return {
      x: minX, y: minY,
      w: maxX - minX, h: maxY - minY
    };
  }

  /**
    * Capture image
    * **/
  async captureImage(landmarks) {
    this.isProcessingCapture = true;  // lock to block repeated capture
    const multiAngleFaceDetectionForm =
      getShadowRoot().querySelector(`#multiAngleFaceDetection`);

    const canvas = multiAngleFaceDetectionForm.querySelector('#canvas');
    const ctx = canvas.getContext('2d');
    const video = multiAngleFaceDetectionForm.querySelector('#video');
    const instructions = multiAngleFaceDetectionForm.querySelector('#instructions');


    // 1) get raw video dimensions
    const srcW = video.videoWidth;
    const srcH = video.videoHeight;

    // 2) compute face box in that space
    const box = this.getFaceBox(landmarks, srcW, srcH);

    // 3) resize hidden canvas to the face-box size
    canvas.width = box.w;
    canvas.height = box.h;

    // Mirror the captured face crop so it matches the selfie-style preview.
    ctx.save();
    ctx.translate(box.w, 0);
    ctx.scale(-1, 1);
    ctx.drawImage(
      video,
      box.x, box.y, box.w, box.h,   // source rect in raw video
      0, 0, box.w, box.h    // dest on hidden canvas
    );
    ctx.restore();

    // Check face direction again 
    let direction = this.estimatePose(landmarks, srcW, srcH, this.directions[this.currentPose]);

    if (direction) {
      // 5) export & display
      const dataURL = canvas.toDataURL('image/jpeg');
      const img = new Image();
      img.src = dataURL;

      img.onload = async () => {

        //Check image blurry or not
        let isblurry = await this.CheckImageQuality(img, this.directions[this.currentPose]);
        if (!isblurry) {

          this.capturedImages.push(dataURL);

          // play picture capture sound
          await ShutterSound.play();

          //Convert in to blob
          canvas.toBlob(async (blob) => {
            if (!blob) {
              console.error('Failed to create Blob from canvas.');
              return;
            }
            //Append the image to the form
            const capturedDirection = this.directions[this.currentPose];
            if (capturedDirection === 'up') {
              this.capturedUpRatio = this.getVerticalPoseRatio(
                landmarks[33],
                landmarks[263],
                landmarks[1],
                srcW,
                srcH
              );
              this.capturedUpDownMetric = this.getDownPoseMetric(
                landmarks[33],
                landmarks[263],
                landmarks[1],
                landmarks[152]
              );
            }
            this.formData.append(`images`, blob, capturedDirection + '.png');
            multiAngleFaceDetectionForm.querySelector('#capturedImages').appendChild(img);
            this.capturedDirections[capturedDirection] = true;
            instructions.textContent = `${this.getDirectionText(capturedDirection)} captured`;
            this.renderDirectionStatus();
            this.setFaceGuideState(true);


            // baseline save & next pose
            if (this.currentPose === 0) this.baselineFaceHeight = this.lastFaceHeight;
            setTimeout(() => {
              this.currentPose++;
              setError("");
              this.poseHoldStartAt = null;
              this.isProcessingCapture = false;
              this.promptNextPose();
            }, 600);
          });
        }
        else {
          this.setFaceGuideState(false, true);
          this.updateInstruction(instructions);
          this.isProcessingCapture = false;
          this.capturing = true;
        }
      }
    }
    else {
      this.setFaceGuideState(false, true);
      setError(` Face is  not proper   ${this.directions[this.currentPose].toUpperCase()} direction. Please try again...`);
      this.updateInstruction(instructions);
      this.isProcessingCapture = false;
      this.capturing = true;
    }
  }

  /**
    * Get next direction
    * **/
  promptNextPose() {
    const multiAngleFaceDetectionForm =
      getShadowRoot().querySelector(`#multiAngleFaceDetection`);
    const instructions = multiAngleFaceDetectionForm.querySelector('#instructions');
    const btn_continue = multiAngleFaceDetectionForm.querySelector('#btn-continue');
    const btn_skip = multiAngleFaceDetectionForm.querySelector('#skip');
    const videoContainer = multiAngleFaceDetectionForm.querySelector('#videoContainer');
    const faceCaptureError = multiAngleFaceDetectionForm.querySelector('#faceCaptureError');
    const faceCaptureMessage = multiAngleFaceDetectionForm.querySelector('#faceCapture-message');
    const loader = multiAngleFaceDetectionForm.querySelector('#faceLoading');

    if (this.currentPose >= this.directions.length) {
      instructions.textContent = "✅ All poses captured!";
      this.capturing = false;
      this.renderDirectionStatus();

      setLoading(true)
      videoContainer.style.display = 'none'
      loader.style.display = 'flex';
      instructions.style.display = 'none';
      const submittingRunId = this.captureRunId;
      let params = new URLSearchParams(window.location.search),
        internalTest = params.get("internalTest");
      if (internalTest) {
        params.set("internalTest", true);
      }
      else {
        params.set("internalTest", false);
      }

      if (this.sessionData.configurationType !== 2)
        btn_skip.disabled = true;
      request.post(`/multianglefacecapture/${getSessionId()}/?${params}`, this.formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then(({ data }) => {
          if (submittingRunId !== this.captureRunId) return;
          setLoading(false);
          setSessionData(data.data);
          nextPrev(1);
        })
        .catch(({ response }) => {
          if (submittingRunId !== this.captureRunId) return;
          faceCaptureMessage.innerText = response.data?.message;
          faceCaptureError.style.display = 'flex';
          faceCaptureMessage.style.display = 'flex';
          setLoading(false);

          if (response?.data &&
            response.data?.errors &&
            response?.data?.errors?.REDIRECT_BACK) {
            // Hide the button after all multi-angle face capture attempts are completed
            btn_continue.style.display = 'none';
            videoContainer.style.display = 'none'
            faceCaptureMessage.innerText = response?.data?.errors?.REDIRECT_BACK;
          } else {
            if (response.data?.message && response.data.message.includes("not match")) {
              btn_continue.innerHTML = `ReTry    <span class="loading-icon"><svg class="svg" width="20px" height="20px" aria-hidden="true" role="img"><use href="#svg__loader" xlink:href="#svg__loader"></use></svg></span>`;
            }
          }
        }).finally(() => {
          if (submittingRunId !== this.captureRunId) return;
          setLoading(false);
          this.stopCamera();
          if (this.sessionData.configurationType !== 2)
            btn_skip.disabled = false;
          this.formData = new FormData();
          loader.style.display = 'none';
        });
    }
    else {
      this.capturing = true;
      this.poseHoldStartAt = null;
      this.poseTransitionUntil = Date.now() + this.poseTransitionDelayMs;
      this.hasPoseResetSincePrompt = false;
      this.setFaceGuideState(false, true);
      this.renderDirectionStatus();
      this.updateInstruction(instructions);
    }
  }


  /**
    * Check face is fully visible in frame
    **/
  isFaceFullyVisible(landmarks, width, height) {
    const keyIndices = [
      10,   // top of forehead
      159,  // left eye top lid
      386,  // right eye top lid
      33,   // left eye corner
      263,  // right eye corner
      152,  // chin
      1     // nose tip
    ];

    for (const index of keyIndices) {
      const point = landmarks[index];
      const x = point.x * width;
      const y = point.y * height;

      if (x < 0 || x > width || y < 0 || y > height) {
        return false; // A key part of the face is outside the frame
      }
    }
    return true;
  }

  hasActiveCameraStream() {
    return !!this.stream && this.stream.getTracks().some((track) => track.readyState === "live");
  }

  getCameraConstraintAttempts(constraints) {
    const videoConstraints = constraints?.video || {};

    return [
      constraints,
      {
        video: {
          width: videoConstraints.width,
          height: videoConstraints.height,
        },
      },
      { video: true },
    ];
  }

  async tryAcquireCameraStream(constraintAttempts) {
    let lastError;

    for (const constraints of constraintAttempts) {
      try {
        return await navigator.mediaDevices.getUserMedia(constraints);
      } catch (err) {
        lastError = err;
      }
    }

    throw lastError;
  }

  async getFallbackDeviceConstraintAttempts() {
    if (!navigator.mediaDevices?.enumerateDevices) return [];

    const devices = await navigator.mediaDevices.enumerateDevices();
    return devices
      .filter((device) => device.kind === "videoinput")
      .map((device) => ({
        video: {
          deviceId: { exact: device.deviceId },
        },
      }));
  }

  /**
   * Setup camera
   */
  async setupCamera() {
    if (this.hasActiveCameraStream() || this.isCameraStarting) return; // Prevent re-initialization
    this.isCameraStarting = true;
    const multiAngleFaceDetectionForm =
      getShadowRoot().querySelector(`#multiAngleFaceDetection`);
    const canvas = multiAngleFaceDetectionForm.querySelector('#canvas');
    const instructions = multiAngleFaceDetectionForm.querySelector('#instructions');

    const video = multiAngleFaceDetectionForm.querySelector('#video');
    // Mobile-only: this flow is only ever launched on a phone camera.
    const constraints = {
      video: {
        width: { ideal: 360 },
        height: { ideal: 640 },
        facingMode: "user"
      }
    };

    const constraintAttempts = this.getCameraConstraintAttempts(constraints);

    this.videoWidth = constraints.video.width?.ideal || this.videoWidth;
    this.videoHeight = constraints.video.height?.ideal || this.videoHeight;
    try {
      let stream;
      try {
        stream = await this.tryAcquireCameraStream(constraintAttempts);
      } catch (err) {
        const shouldRetry = ["NotReadableError", "OverconstrainedError", "AbortError"].includes(err?.name);
        if (!shouldRetry) throw err;
        const fallbackDeviceConstraints = await this.getFallbackDeviceConstraintAttempts();
        if (!fallbackDeviceConstraints.length) throw err;
        stream = await this.tryAcquireCameraStream(fallbackDeviceConstraints);
      }

      this.stream = stream;
      video.srcObject = stream;
      video.onloadedmetadata = async () => {
        await video.play();
        this.updateCanvasDimensions();

        canvas.width = this.videoWidth;
        canvas.height = this.videoHeight;

        const processFrame = async () => {
          if (!this.stream || video.readyState < 2) return;
          await this.faceMesh.send({ image: video });
          this.frameRequest = window.requestAnimationFrame(processFrame);
        };

        this.camera = { stop: () => window.cancelAnimationFrame(this.frameRequest) };
        this.frameRequest = window.requestAnimationFrame(processFrame);
      };
      return;
    } catch (err) {
      this.isCameraStarting = false;
      console.error("Camera error:", err);
      instructions.textContent = "Could not access camera.";
      instructions.style.color = "red";
      return;
    } finally {
      this.isCameraStarting = false;
    }
  }

  /**
   * Stop camera
   */
  stopCamera() {
    const multiAngleFaceDetectionForm =
      getShadowRoot().querySelector(`#multiAngleFaceDetection`);
    const video = multiAngleFaceDetectionForm.querySelector('#video');
    const canvas = multiAngleFaceDetectionForm.querySelector('#canvas');


    // Stop MediaPipe camera
    if (this.camera) {
      this.camera.stop(); // MediaPipe Camera has stop()
      this.camera = null;
    }
    if (this.frameRequest) {
      window.cancelAnimationFrame(this.frameRequest);
      this.frameRequest = null;
    }

    // Stop all video tracks (camera stream)
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      this.stream = null;
    }

    // ✅ 3. Clear video element to fully release camera
    video.pause();         // Important for iOS
    video.srcObject = null;
    video.removeAttribute("src"); // force unload in Safari
    video.load();

    // Optionally clear the video and canvas
    const ctx = canvas.getContext("2d");
    ctx && ctx.clearRect(0, 0, canvas.width, canvas.height);
    this.setFaceGuideState(false, false);
  }


  /**
   * Update the canvas dimensions based on the video element's dimensions.
   */
  updateCanvasDimensions() {
    const multiAngleFaceDetectionForm =
      getShadowRoot().querySelector(`#multiAngleFaceDetection`);

    const videoContainer = multiAngleFaceDetectionForm.querySelector('#videoContainer');
    const landmarksCanvas = multiAngleFaceDetectionForm.querySelector('#landmarksCanvas');
    const overlayCtx = landmarksCanvas.getContext('2d');


    const dpr = window.devicePixelRatio || 1;
    const cw = videoContainer.clientWidth;
    const ch = videoContainer.clientHeight;

    // 1. Set the CSS size
    landmarksCanvas.style.width = cw + 'px';
    landmarksCanvas.style.height = ch + 'px';
    // 2. Allocate the real pixel buffer
    landmarksCanvas.width = cw * dpr;
    landmarksCanvas.height = ch * dpr;

    // 3. Scale drawing back to CSS coords
    overlayCtx.resetTransform();    // clear any old scale
    overlayCtx.scale(dpr, dpr);

    // (repeat for your hidden capture-canvas if you draw there too)

    this.videoWidth = cw;
    this.videoHeight = ch;
  }

  /**
   * Check image quality
   */
  async CheckImageQuality(image, direction) {

    let cv = await this.initOpenCV();
    if (!cv) {
      console.error("OpenCV is not available. Skipping blur check.");
      return false;
    }

    // Read and convert image to grayscale
    let src = cv.imread(image); // 'image' should be the canvas/image element
    let laplacian = new cv.Mat();
    let mean = new cv.Mat();
    let stddev = new cv.Mat();

    try {
      cv.cvtColor(src, src, cv.COLOR_RGBA2GRAY, 0); // Use RGBA to GRAY just in case

      // Compute Laplacian to detect edges
      cv.Laplacian(src, laplacian, cv.CV_64F);

      // Compute standard deviation of Laplacian to estimate sharpness
      cv.meanStdDev(laplacian, mean, stddev);

      let sharpnessScore = stddev.data64F[0] * 2;
      let isBlurry = sharpnessScore < 15 // Lower threshold reduces false blurry rejections

      //console.log("Sharpness Score:", sharpnessScore);

      if (isBlurry) {
        setError(`Face ${direction} is blurry. Please try again.`);
      } else {
        setError("")
      }

      return isBlurry;
    } catch (err) {
      console.error("Error checking image blur:", err);
      return false;
    } finally {
      src.delete();
      laplacian.delete();
      mean.delete();
      stddev.delete();
    }
  }

  SendOption(hasUserMtipleImage) {
    setError("");

    request
      .post(`/facecaptureoptions/${getSessionId()}`, {
        hasUserMultipleImage: hasUserMtipleImage,
      })
      .then(({ data }) => {
        setSessionData(data.data);
        nextPrev(1);
      })
      .catch(({ response }) => {
        setError(response);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  /**
   * Init Facemesh 
   */
  async initFaceMesh() {
    try {
      const FaceMesh = await this.loadFaceMeshScript();

      this.faceMesh = new FaceMesh({
        locateFile: (file) => `https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/${file}`
      });

      console.log("✅ FaceMesh is ready!", this.faceMesh);

      // Now continue with your faceMesh setup or camera connection
      this.faceMesh.setOptions({
        maxNumFaces: 1,
        refineLandmarks: true,
        minDetectionConfidence: 0.5,
        minTrackingConfidence: 0.5
      });

      // continue your app logic here...
    } catch (err) {
      console.error("❌ Error loading FaceMesh:", err);
    }
  }

  /**
   * Load facemesh
   * @returns 
   */
  loadFaceMeshScript() {
    return new Promise((resolve, reject) => {
      if (window.FaceMesh) {
        // Already loaded
        resolve(window.FaceMesh);
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/face_mesh.js';
      script.async = true;

      script.onload = () => {
        if (window.FaceMesh) {
          resolve(window.FaceMesh);
        } else {
          reject(new Error('FaceMesh not found after script load.'));
        }
      };

      script.onerror = () => reject(new Error('Failed to load FaceMesh script.'));
      document.head.appendChild(script);
    });
  }

  /**
   * Load open cv
   * @returns 
   */
  loadOpenCVScript() {
    return new Promise((resolve, reject) => {
      if (window.cv) {
        resolve(window.cv);
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/@techstark/opencv-js@4.11.0-release.1/dist/opencv.min.js';

      script.async = true;

      script.onload = () => {
        if (window.cv) {

          resolve(window.cv);

        } else {
          reject(new Error('cv not found after script load.'));
        }
      };

      script.onerror = () => reject(new Error('Failed to load OpenCV script.'));
      document.head.appendChild(script);
    });
  }

  /**
   * Init opencv
   * @returns 
   */
  async initOpenCV() {
    try {
      const cv = await this.loadOpenCVScript();

      // Now you can use OpenCV
      console.log("OpenCV is ready", cv);
      return cv;
      // Optionally, call CheckImageQuality or other functions now
    } catch (err) {
      console.error("Error loading OpenCV:", err);
    }
  }

  updateInstruction(instructions) {
    instructions.innerHTML = ` <span style="font-size: 36px;" id="direction-icon"> ${this.colorMap[this.directions[this.currentPose]]}</span> 
                <span style="font-size: 18px; margin-left: 10px;" id="message"> ${this.getDirectionPrompt(this.directions[this.currentPose])}</span>
            `
  }

}

export default MultiAngleFaceCapture;
